import React, { Component } from 'react';
import { message } from 'antd';
import { connect } from 'react-redux';
import * as Page from 'HOC/Layout/PageContainer';
import ProductTypesTable from 'components/ProductType/ProductTypesTable';
import styles from './ProductTypePage.module.css';

import { fetchProductTypes } from 'store/actions/index';
import ProductTypeImageModal from 'components/ProductType/ProductTypeImageModal';

const { Container, Title } = Page;

class ProductTypePage extends Component {
  state = {
    showModal: false,
    uploadImageID: null,
    uploadImagePlatform: null,
  };

  componentDidMount = () => {
    const { fetchProductTypes } = this.props;
    fetchProductTypes();
  };

  render = () => {
    const { loading, product_types, token } = this.props;

    return (
      <Container type="2x3">
        <Title title="Product Types" button={true} onClick={this.toggleModal} />
        <div className={styles.Main}>
          <ProductTypesTable loading={loading} product_types={product_types} />
          <ProductTypeImageModal
            product_types={product_types}
            visible={this.state.showModal}
            onCancel={this.toggleModal}
            onOk={this.toggleModal}
            handleSelectType={this.handleSelectType}
            handleSelectPlatform={this.handleSelectPlatform}
            handleReset={this.handleResetUpload}
            handleUploadChange={this.handleUploadChange}
            token={token}
            product_type_id={this.state.uploadImageID}
            platform={this.state.uploadImagePlatform}
          />
        </div>
      </Container>
    );
  };

  toggleModal = () => {
    this.setState(prevState => ({
      ...prevState,
      showModal: !this.state.showModal,
      uploadImageID: null,
      uploadImagePlatform: null,
    }));
  };

  handleSelectType = id => {
    this.setState(prevState => ({
      ...prevState,
      uploadImageID: id,
    }));
  };

  handleSelectPlatform = platform => {
    this.setState(prevState => ({
      ...prevState,
      uploadImagePlatform: platform,
    }));
  };

  handleResetUpload = () => {
    this.setState(prevState => ({
      ...prevState,
      uploadImageID: null,
      uploadImagePlatform: null,
    }));
  };

  handleUploadChange = (info, onSuccess) => {
    const status = info.file.status;
    const { fetchProductTypes } = this.props;

    if (status !== 'uploading') {
      console.log(info.file, info.fileList);
    }

    if (status === 'done') {
      message.success(`${info.file.name} file uploaded successfully.`);
      fetchProductTypes();
      this.toggleModal();
    } else if (status === 'error') {
      message.error(`${info.file.name} file upload failed.`);
    }
  };
}

const mapStateToProps = state => {
  const { loading, product_types } = state.product_type;
  const { token } = state.auth;
  return {
    loading,
    product_types,
    token,
  };
};

const mapDispatchToProps = {
  fetchProductTypes,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProductTypePage);



// WEBPACK FOOTER //
// ./src/containers/ProductType/ProductTypePage.js